module.exports = __webpack_public_path__ + "static/awtmt-29fbd12d5307254deb5640211f6a9eef.jpg";